import { useMutation } from '@tanstack/react-query';
import { executeAction } from '../api';
import type { ActionExecuteRequest, ActionExecuteResponse } from '../types';
import { getData } from '../../../utils/functional/fp';

export function useActionExecution() {
  return useMutation({
    mutationFn: (request: ActionExecuteRequest) =>
      executeAction({ data: request }).then(getData) as Promise<ActionExecuteResponse>,
  });
}
